<template>
  <div class="select-card-root">
    <empty-cards v-if="cards.length === 0" @add-new-card="handleAddNewCard" />
    <cards-list
      v-else
      :cards="cards"
      @click-on-card="handleClick"
      @add-new-card="handleAddNewCard"
    />
  </div>
</template>

<script>
import EmptyCards from './EmptyCards.vue'
import CardsList from './CardsList.vue'

export default {
  components: { CardsList, EmptyCards },

  props: {
    // Array of objects with details about each card
    cards: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleAddNewCard() {
      this.$emit('add-new-card')
    },

    handleClick(cardId) {
      this.$emit('click-on-card', cardId)
    },
  },
}
</script>

<style scoped lang="scss">
.select-card-root {
  min-height: 600px;
}
</style>
